import { render, staticRenderFns } from "./TrainingModal.vue?vue&type=template&id=ef8e45f8&scoped=true&"
import script from "./TrainingModal.vue?vue&type=script&lang=js&"
export * from "./TrainingModal.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModal.vue?vue&type=style&index=0&id=ef8e45f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8e45f8",
  null
  
)

export default component.exports